<div class="main-container">
  <div class="table-header-controls" [formGroup]="tableForm">
    <h4>{{ tableName }}</h4>
    <div class="controls">
      <app-select
        [formControl]="tableForm | handleFormControl: 'searchBy'"
        [options]="menuOptions"
        (selectedOptionChange)="setInputDisableState($event)"
      ></app-select>
      <app-input-text
        [formControl]="tableForm | handleFormControl: 'search'"
        [ngClass]="{ 'input-disabled': isDisabledSearch }"
      ></app-input-text>
      <i class="pi pi-search"></i>
    </div>
  </div>
  <div class="table-wrapper">
    <div class="table-container" #tableContainer>
      <table [ngClass]="{ 'stick-column': hasVerticalScroll }">
        <!-- Este codigo fue generado por Github Copilot Chat -->
        <caption class="sr-only">
          {{
            tableName
          }}
          - Tabla con
          {{
            items.length
          }}
          elemento{{
            items.length !== 1 ? 's' : ''
          }}. Use los controles de búsqueda para filtrar resultados y los
          botones de encabezado para ordenar columnas.
        </caption>
        <!-- Este codigo fue generado por Github Copilot Chat -->
        <thead>
          <tr>
            @if (showCheckboxes) {
              <th class="checkbox-column">
                <app-input-check
                  [checked]="allSelected"
                  [showBorder]="false"
                  (checkedChange)="toggleSelectAll($event)"
                ></app-input-check>
              </th>
            }
            @if (showActions && actionsPosition === 'left') {
              <th class="actions-column frozen-column">
                <div class="th-content">
                  <i class="icon-agregar-azul th-icon"></i>
                  <span>Acciones</span>
                </div>
              </th>
            }
            @for (column of visibleColumns; track column.key; let i = $index) {
              <th
                [class.frozen-column]="isColumnFrozen(column.key)"
                [attr.data-column-index]="i"
              >
                <div class="th-content">
                  @if (column.icon) {
                    <i [class]="column.icon + ' th-icon'"></i>
                  }
                  <span>{{ column.label }}</span>
                  <!-- Este codigo fue generado por Github Copilot Chat -->
                  <button
                    type="button"
                    class="sort-btn pi"
                    [ngClass]="{
                      'pi-arrow-up':
                        currentSort.orderBy === column.key &&
                        currentSort.orderType === orderEnum.ASC,
                      'pi-arrow-down':
                        currentSort.orderBy === column.key &&
                        currentSort.orderType === orderEnum.DESC,
                      'pi-sort-alt': currentSort.orderBy !== column.key,
                      'pi-active': currentSort.orderBy === column.key
                    }"
                    (click)="
                      sort(
                        column.key,
                        currentSort.orderBy === column.key &&
                          currentSort.orderType === orderEnum.ASC
                          ? orderEnum.DESC
                          : orderEnum.ASC
                      )
                    "
                    [attr.aria-label]="
                      'Sort ' +
                      column.label +
                      (currentSort.orderBy === column.key
                        ? currentSort.orderType === orderEnum.ASC
                          ? ' descending'
                          : ' ascending'
                        : '')
                    "
                  ></button>
                  <!-- Este codigo fue generado por Github Copilot Chat -->
                </div>
              </th>
            }
            @if (showActions && actionsPosition === 'right') {
              <th class="actions-column">
                <div class="th-content">
                  <i class="icon-agregar-azul th-icon"></i>
                  <span>Acciones</span>
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @if (items.length === 0) {
            <!-- Empty state message -->
            <tr class="empty-state-row">
              <td
                [attr.colspan]="visibleColumns.length + 1"
                class="text-center py-8"
              >
                <div class="flex flex-col items-center gap-2">
                  <i
                    class="icon-buscar text-gray-400"
                    style="font-size: 3rem"
                  ></i>
                  <p class="text-gray-600 text-base m-0">
                    {{ noDataMessage }}
                  </p>
                </div>
              </td>
            </tr>
          }
          <!-- Data rows -->
          @for (item of items; track $index) {
            <tr>
              @if (showCheckboxes) {
                <td
                  class="checkbox-column"
                  (click)="onCheckboxClick($event, item)"
                  (keypress)="onCheckboxClick($event, item)"
                >
                  <app-input-check
                    [checked]="isItemSelected(item)"
                    [showBorder]="false"
                    (checkedChange)="toggleSelectItem(item, $event)"
                  ></app-input-check>
                </td>
              }
              @if (showActions && actionsPosition === 'left') {
                <td class="actions-column frozen-column">
                  @if (useActionMenu) {
                    <app-action-menu
                      [config]="getActionMenuConfigForItem(item)"
                      [item]="item"
                      (actionClick)="onActionMenuClick($event)"
                    ></app-action-menu>
                  } @else {
                    @for (action of tableActions; track $index) {
                      @if (!action.isHidden || !action.isHidden(item)) {
                        <button
                          type="button"
                          class="action-btn"
                          [disabled]="
                            action.isDisabled ? action.isDisabled(item) : false
                          "
                          [title]="getActionTooltip(action, item)"
                          (click)="handleActionClick(action, item)"
                          [attr.aria-label]="'Action ' + action.icon"
                        >
                          <i [class]="action.icon"></i>
                        </button>
                      }
                    }
                  }
                </td>
              }
              @for (
                column of visibleColumns;
                track column.key;
                let i = $index
              ) {
                <td
                  [class.frozen-column]="isColumnFrozen(column.key)"
                  [class.text-center]="column.align === 'center'"
                  [class.text-right]="column.align === 'right'"
                  [attr.data-column-index]="i"
                >
                  @if (isCollaboratorsColumn(column)) {
                    <app-avatar-collapsible
                      [collaborators]="item[column.key] | collaborators"
                    ></app-avatar-collapsible>
                  } @else if (isExamTypeColumn(column)) {
                    <div
                      class="exam-type-badge"
                      [ngClass]="item[column.key] | examTypeBadge"
                    >
                      <span class="exam-type-text">{{  
                        getCellDisplayValue(column, item)
                      }}</span>
                    </div>
                  } @else if (isPriorityColumn(column)) {
                    <div
                      class="priority-badge"
                      [ngClass]="getPriorityBadgeClasses(item[column.key])"
                    >
                      <span
                        class="priority-dot"
                        [ngClass]="getPriorityDotClass(item[column.key])"
                      ></span>
                      <span class="priority-text">{{
                        getCellDisplayValue(column, item)
                      }}</span>
                    </div>
                  } @else if (isStatusColumn(column)) {
                    <div
                      class="status-badge"
                      [ngClass]="getStatusBadgeClasses(item[column.key])"
                    >
                      <span
                        class="status-dot"
                        [ngClass]="getStatusDotClass(item[column.key])"
                      ></span>
                      <span class="status-text">{{
                        getCellDisplayValue(column, item)
                      }}</span>
                    </div>
                  } @else if (isBooleanIconColumn(column)) {
                    <div
                      class="boolean-icon-cell"
                      [class.clickable]="
                        isBooleanIconClickable(column) && item[column.key]
                      "
                      [attr.role]="
                        isBooleanIconClickable(column) && item[column.key]
                          ? 'button'
                          : null
                      "
                      [attr.aria-label]="
                        isBooleanIconClickable(column) && item[column.key]
                          ? 'Ver detalles de ' + column.label
                          : null
                      "
                      [attr.tabindex]="
                        isBooleanIconClickable(column) && item[column.key]
                          ? 0
                          : null
                      "
                      (click)="onBooleanIconClick(column, item, $event)"
                      (keydown.enter)="onBooleanIconClick(column, item, $event)"
                    >
                      @if (item[column.key]) {
                        <i [class]="getBooleanIcon(column)"></i>
                      }
                    </div>
                  } @else if (isBooleanTextColumn(column)) {
                    <div class="boolean-text-cell">
                      {{ getBooleanText(column, item[column.key]) }}
                    </div>
                  } @else {
                    <div
                      class="cell-content"
                      [ngClass]="getColumnClass(column.key, item)"
                      appShowTooltipOnOverflow
                      [attr.data-tooltip]="getTooltipText(column, item)"
                      [attr.data-tooltip-always]="
                        shouldAlwaysShowTooltip(column) ? '' : null
                      "
                    >
                      @if (getPrefixIcon(column, item); as prefixIcon) {
                        <i
                          [class]="prefixIcon.iconClass"
                          [title]="prefixIcon.title"
                          class="cell-prefix"
                        ></i>
                      }
                      {{ getCellDisplayValue(column, item) }}
                      @if (getSuffixIcon(column, item); as suffixIcon) {
                        <i
                          [class]="suffixIcon.iconClass"
                          [title]="suffixIcon.title"
                          class="cell-suffix"
                        ></i>
                      }
                    </div>
                  }
                </td>
              }
              @if (showActions && actionsPosition === 'right') {
                <td class="actions-column">
                  @if (useActionMenu) {
                    <app-action-menu
                      [config]="getActionMenuConfigForItem(item)"
                      [item]="item"
                      (actionClick)="onActionMenuClick($event)"
                    ></app-action-menu>
                  } @else {
                    @for (action of tableActions; track $index) {
                      @if (!action.isHidden || !action.isHidden(item)) {
                        <button
                          type="button"
                          class="action-btn"
                          [disabled]="
                            action.isDisabled ? action.isDisabled(item) : false
                          "
                          [title]="getActionTooltip(action, item)"
                          (click)="handleActionClick(action, item)"
                          [attr.aria-label]="'Action ' + action.icon"
                        >
                          <i [class]="action.icon"></i>
                        </button>
                      }
                    }
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-modal
  [title]="modalTitle"
  [data]="modalData"
  [isOpen]="isModalOpen"
  [width]="modalWidth"
  [height]="modalHeight"
  (closeModal)="isModalOpen = false"
>
</app-modal>
